














































import { defineComponent, ref } from '@nuxtjs/composition-api';
import { useAuth } from '~/features/auth';
import { useCartAttributes } from '~/features/cart';

export default defineComponent({
  name: 'CartPaymentSummary',
  setup() {
    const { isLoggedIn } = useAuth();
    const enableLoyaltyVoucher = ref<boolean>(true);

    const {
      total,
      subtotal,
      shippingFees,
      hasInvalidItems,
      discounts,
      spinTheWheelData,
      paymentFee,
    } = useCartAttributes();

    return {
      subtotal,
      total,
      hasInvalidItems,
      shippingFees,
      isLoggedIn,
      discounts,
      spinTheWheelData,
      paymentFee,
      enableLoyaltyVoucher,
    };
  },
});
